import React, { useState } from 'react';
import {
  MDBCollapse,
  MDBNavbar,
  MDBNavbarNav,
  MDBNavbarToggler,
} from 'mdbreact';
import { Button } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { getUsername, isUserLoggedIn, logOut } from '../components/user/User';
import LinkComponent from '../components/LinkComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import '../style/Header.css';

const Header = () => {
  const navigate = useNavigate();
  const [collapse, setCollapse] = useState(false);

  const toggleCollapse = () => setCollapse(!collapse);
  const closeNavBarMenu = () => setCollapse(false);

  const handleLogout = (e) => {
    e.preventDefault();
    logOut();
    navigate('/');
  };

  return (
    <div style={{ marginBottom: '90px' }}>
      <header>
        <MDBNavbar id="header-navbar" color="blue" dark expand="md" fixed="top">
          <Link
            style={{ marginRight: '1rem' }}
            to="/"
            onClick={closeNavBarMenu}
          >
            <img src="logo192.png" height="30" alt="logo" />
          </Link>
          <MDBNavbarToggler onClick={toggleCollapse} />
          <MDBCollapse isOpen={collapse} navbar onClick={closeNavBarMenu}>
            <MDBNavbarNav left>
              <LinkComponent path="/" label="Hooajad" />
              <LinkComponent path="/clubs" label="Klubid" />
              <LinkComponent path="/future_matches" label="Eelolevad mängud" />
              <LinkComponent path="/statistics" label="Statistika" />
            </MDBNavbarNav>
            <MDBNavbarNav right>
              {isUserLoggedIn() ? (
                <>
                  <div className="justify-content-center align-items-center d-flex mr-3">
                    <FontAwesomeIcon className="mr-1" icon={faUser} />{' '}
                    {getUsername()}
                  </div>
                  <LinkComponent path="/admin" label="Administreerimine" />
                  <div
                    className="nav-item"
                    style={{
                      alignContent: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <Button
                      variant="link nav-link"
                      style={{
                        padding: 0,
                        margin: 0,
                        textTransform: 'none',
                        fontWeight: 300,
                      }}
                      onClick={handleLogout}
                    >
                      Logi välja
                    </Button>
                  </div>
                </>
              ) : (
                <LinkComponent path="/login" label="Logi sisse" />
              )}
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBNavbar>
      </header>
      {collapse && (
        <div id="full-page-invisible-layer" onClick={closeNavBarMenu} />
      )}
    </div>
  );
};

export default Header;
